import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
// @mui
import { useTheme } from '@mui/material/styles';
import { Grid, Container, Typography, Box, CircularProgress } from '@mui/material';
// components
import { useSelector } from 'react-redux';
// sections
import {
  AppTasks,
  AppNewsUpdate,
  AppOrderTimeline,
  AppCurrentVisits,
  AppWebsiteVisits,
  AppTrafficBySite,
  AppWidgetSummary,
  AppCurrentSubject,
  AppConversionRates,
} from '../../sections/@dashboard/app';

import { getDashboardData } from '../../api/superadmin/commonAPIs';

const getColor = ['secondary', 'info', 'warning', 'error']
// ----------------------------------------------------------------------

export default function DashboardAppPage() {
  const theme = useTheme();
  const adminUserState = useSelector((state) => state.adminUser)
  const { isAuthenticated, user } = adminUserState

  const [isLoading, setIsLoading] = useState(false)
  const [dashboardData, setDashboardData] = useState(false)
  // console.log(adminUserState)
  const fetchData = async () => {
    setIsLoading(true)
    try {
      const { data } = await getDashboardData();
      setDashboardData(data.dashboard)
      // console.log(data);
      setIsLoading(false)
    }
    catch (e) {
      setIsLoading(false)
      // console.log({ e });
    }
  }

  // get admins list
  // useEffect(() => {
  //   fetchData();
  // }, []);

  return (
    <>
      <Helmet>
        <title> Dashboard | Teller One </title>
      </Helmet>
      <Box sx={{ height: '100%' }}>
        {!isLoading ?
          <Box >
            <Typography variant="h4" sx={{ mb: 5 }}>
              Hi, Welcome back
            </Typography>
            {/* {dashboardData &&
              <Grid container spacing={3}>
                {Object.entries(dashboardData.superAdmins).map(([key, value], ind) => (
                  <Grid item xs={12} sm={6} md={3} key={ind}>
                    <AppWidgetSummary title={key} total={value} icon={'icon-park-outline:file-staff'} color={getColor[ind]} />
                  </Grid>
                ))}
                <Grid item xs={12} md={6} lg={6}>
                  <AppWebsiteVisits
                    title="Total Accounts"
                    subheader="(+1.23%) than last year"
                    chartLabels={[
                      '01/01/2023',
                      '02/01/2023',
                      '03/01/2023',
                      '04/01/2023',
                      '05/01/2023',
                    ]}
                    chartData={[
                      {
                        name: 'Accounts Added',
                        type: 'column',
                        fill: 'solid',
                        data: [1, 2, 11, 4, 3],
                      },

                    ]}
                  />
                </Grid>

                <Grid item xs={12} md={6} lg={6}>
                  <AppCurrentVisits
                    title="Account Summary"
                    chartData={
                      Object.entries(dashboardData.hospitalAccounts).map(([label, value], ind) => ({ label, value })).filter((item) => item.label !== 'Total Accounts')
                    }
                    chartColors={[
                      theme.palette.primary.main,
                      theme.palette.info.main,
                      theme.palette.warning.main,
                      theme.palette.error.main,
                    ]}
                  />
                </Grid>
              </Grid>} */}
          </Box>
          :
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}><CircularProgress /></Box>}
      </Box>
    </>
  );
}
